import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { USECASE } from "../../../model/usecase.model";
import { DateFormatUtils } from "../../../utils/date-format.utils";
import { HttpService } from "../http.service";

@Injectable({
  providedIn: "root",
})
export class BioSealService extends HttpService {
  constructor(private _http: HttpClient) {
    super(_http);
  }
  leftPad(number, targetLength) {
    var output = number + "";
    while (output.length < targetLength) {
      output = "0" + output;
    }
    return output;
  }

  public getBioSeal(
    format,
    personalData,
    documentData,
    practitionerData,
    testData,
    eventData,
    token,
    faceImage,
    url,
    biometrics,
    barcodeType,
    usecase
  ): Observable<any> {
    let headers = new HttpHeaders();
    const dataToSend = {};

    headers = headers.append("Authorization", "Bearer " + token);
    const options = {};
    let urlToSend = url + "/api/bioseal/create";
    if (faceImage) {
      dataToSend["faceImage"] = faceImage;
      if (usecase === USECASE.GENERIC) {
        if (biometrics == "facial") {
          urlToSend = urlToSend + "?storeTemplate=true&storePicture=false";
        }
        if (biometrics == "upload") {
          urlToSend = urlToSend + "?storeTemplate=false&storePicture=true";
        }
        if (biometrics == "both") {
          urlToSend = urlToSend + "?storeTemplate=true&storePicture=true";
        }
        if (biometrics == "none") {
          urlToSend = urlToSend + "?storeTemplate=false&storePicture=false";
        }
      }
      if (usecase === USECASE.VACCINATION) {
        urlToSend = urlToSend + "?storeTemplate=false&storePicture=true";
      }
      if (usecase === USECASE.ACCREDITATION) {
        urlToSend = urlToSend + "?storePicture=true&storeTemplate=true";
      }
    } else {
      urlToSend = urlToSend + "?storePicture=false&storeTemplate=false";
    }

    if (barcodeType == "BioSeal") {

      options["responseType"] = "arraybuffer" as "arraybuffer";
      urlToSend = urlToSend + "&format=" + format;

    } else {
      headers = headers.append("Accept", "application/json");
    }

    if (usecase === USECASE.ACCREDITATION) {

      let areas = '';

      if (eventData.parkingAcc) {
        areas += 'PK,';
      }
      if (eventData.grandstandAcc) {
        areas += 'G,';
      }
      if (eventData.pressAcc) {
        areas += 'PR,';
      }
      if (eventData.vipAcc) {
        areas += 'VIP,';
      }
      if (eventData.cloakroomAcc) {
        areas += 'C,';
      }
      if (eventData.restaurantAcc) {
        areas += 'R,';
      }




      urlToSend = urlToSend + "&useCaseId=FFFF&useCaseVersion=7";
      dataToSend["biographics"] = {
        first_name: personalData.firstName,
        last_name: personalData.lastName,
        function: personalData.function.substr(0, 1),
        event_name: eventData.eventName.substr(1),
        event_date: eventData.eventDate + 'T' + eventData.eventTime + ':00Z',
        event_address: eventData.eventAddress,
        accreditations: areas.substr(0, areas.length - 1)
      }
    }

    if (usecase === USECASE.COVID_TEST) {

      urlToSend = urlToSend + "&useCaseId=FFFF&useCaseVersion=3";
      dataToSend["biographics"] = {
        first_name: personalData.firstName,
        last_name: personalData.lastName,
        date_of_birth: personalData.dob,
        gender: personalData.gender,
        loinc: testData.loinc,
        cov_test_result: testData.result,
        test_date: DateFormatUtils.formatISODate(testData.dot)
      }
    }

    if (usecase === USECASE.VACCINATION) {

      urlToSend = urlToSend + "&useCaseId=FFFE&useCaseVersion=1";
      dataToSend["biographics"] = {
        email: personalData.email,
        first_name: personalData.firstName,
        last_name: personalData.lastName,
        doc_id: documentData.certificateNumber,
        date_of_birth: (personalData.dob.indexOf("/") > -1) ? DateFormatUtils.formatDate(personalData.dob) : personalData.dob,
        place_of_birth: personalData.pob,
        phone:
          personalData.phoneNumber === "" || personalData.phoneNumber === null
            ? null
            : personalData.phoneNumber.e164Number,
        id: personalData.idNumber,
        vaccination_location: practitionerData.vaccinationPlace,
        vaccine_name: documentData.vaccinationName,
        vaccination_date: DateFormatUtils.formatISODate(documentData.dov),
        vaccine_id: documentData.batchNumber,
        doctor_last_name: practitionerData.lastName,
        doctor_first_name: practitionerData.firstName,
        doctor_email: practitionerData.email,
        doctor_phone:
          practitionerData.phoneNumber === "" ||
            practitionerData.phoneNumber === null
            ? null
            : practitionerData.phoneNumber.e164Number,
        doctor_title: practitionerData.function,
      };
    }
    if (usecase === USECASE.GENERIC) {
      // country must have minlength 2 in the manifest
      dataToSend["biographics"] = {
        email: personalData.email,
        first_name: personalData.firstName,
        last_name: personalData.lastName,
        date_of_birth: (personalData.dob.indexOf("/") > -1) ? DateFormatUtils.formatDate(personalData.dob) : personalData.dob,
        place_of_birth: personalData.pob,
        gender: personalData.gender,
        address: personalData.address,
        country: personalData.country,
        phone: personalData.phoneNumber === "" || personalData.phoneNumber === null ? null : personalData.phoneNumber.e164Number,
        id: personalData.id,
        doc_id: documentData.documentID,
        doc_type: documentData.documentType,
        doc_date_of_issue: (documentData.dov.indexOf("/") > -1) ? DateFormatUtils.formatDate(documentData.dov) : documentData.dov,
        doc_date_of_expiration: (documentData.doe.indexOf("/") > -1) ? DateFormatUtils.formatDate(documentData.doe) : documentData.doe,
        doc_place_of_issue: documentData.issuePlace,
        misc: documentData.fText,
      };
    }

    options["headers"] = headers;
    return this._http.post(urlToSend, dataToSend, options);
  }

}